
// docs for router https://github.com/thepassle/app-tools/blob/master/router/README.md
import { html } from 'lit';
if (!(globalThis as any).URLPattern) {
  await import("urlpattern-polyfill");
}
import { Router } from '@thepassle/app-tools/router.js';
import { routeGuardPlugin } from "./route-guard";
import { lazy } from '@thepassle/app-tools/router/plugins/lazy.js';
// @ts-ignore

import '../pages/app-home.js';
import { titlePlugin } from "./title.plugin";

const baseURL: string = (import.meta as any).env.BASE_URL;
export function resolveRouterPath(unresolvedPath?: string) {
  var resolvedPath = baseURL;
  if(unresolvedPath) {
    resolvedPath = resolvedPath + unresolvedPath;
  }
  return resolvedPath;
}




export const router = new Router({

    routes: [
      {
        path: resolveRouterPath(),
        title: 'Home',
        render: () => html`<app-home></app-home>`
      },
      {
        path: resolveRouterPath('login'),
        title: 'Login',
        plugins: [
          lazy(() => import('../pages/app-login.js')),
        ],
        render: () => html`<app-login></app-login>`
      },
      {
        path: resolveRouterPath('sign-up'),
        title: 'Sign up',
        plugins: [
          lazy(() => import('../pages/app-sign-up.js')),
        ],
        render: () => html`<app-sign-up></app-sign-up>`
      },
      {
        path: resolveRouterPath('availability'),
        title: 'Availability',
        plugins: [
          lazy(() => import('../pages/app-availability.js')),
        ],
        render: () => html`<app-availability></app-availability>`
      },
      {
        path: resolveRouterPath('fixtures'),
        title: 'Fixtures',
        plugins: [
          lazy(() => import('../pages/app-fixtures.js')),
        ],
        render: () => html`<app-fixtures></app-fixtures>`
      },


{
  path: resolveRouterPath("fixture/:seasonId/:teamId/:fixtureId"),
  title: "Fixture",
  plugins: [lazy(() => import("../pages/app-fixture.js"))],
  render: (context) =>
    html`<app-fixture
      .seasonId=${context.params.seasonId}
      .teamId=${context.params.teamId}
      .fixtureId=${context.params.fixtureId}
    ></app-fixture>`,
},


   {
  path: resolveRouterPath('results'),
  title: 'Results',
  plugins: [
    lazy(() => import('../pages/app-results.js')),
  ],
  render: () => html`<app-results></app-results>`
},

{
  path: resolveRouterPath('scorecard/:fixtureId'),
  title: 'Scorecard',
  plugins: [
    lazy(() => import('../pages/app-scorecard.js')),
  ],
  render: () => html`<app-scorecard></app-scorecard>`
},
      {
        path: resolveRouterPath('stats'),
        title: 'Stats',
        plugins: [
          lazy(() => import('../pages/app-stats.js')),
        ],
        render: () => html`<app-stats></app-stats>`
      },

      {
        path: resolveRouterPath('leaderboard'),
        title: 'Leaderboard',
        plugins: [
          lazy(() => import('../pages/app-leaderboard.js')),
        ],
        render: () => html`<app-leaderboard></app-leaderboard>`
      },
      {
        path: resolveRouterPath('honours-board'),
        title: 'Honours Board',
        plugins: [
          lazy(() => import('../pages/app-honours-board.js')),
        ],
        render: () => html`<app-honours-board></app-honours-board>`
      },
      {
        path: resolveRouterPath('badges'),
        title: 'Badges',
        plugins: [
          lazy(() => import('../pages/app-badges.js')),
        ],
        render: () => html`<app-badges></app-badges>`
      },
      {
        path: resolveRouterPath('team-detail/:teamId'),
        title: 'My Team',
        plugins: [
          lazy(() => import('../pages/app-team-detail.js')),
        ],
        render: (context) => html`<app-team-detail .teamId=${context.params.teamId}></app-team-detail>`
      },
      {
        path: resolveRouterPath('my-team'),
        title: 'My Team',
        plugins: [
          lazy(() => import('../pages/app-my-team.js')),
        ],
        render: () => html`<app-my-team></app-my-team>`
      },
      {
        path: resolveRouterPath('league'),
        title: 'League',
        plugins: [
          lazy(() => import('../pages/app-league.js')),
        ],
        render: () => html`<app-league></app-league>`
      },
      {
        path: resolveRouterPath('profile'),
        title: 'Profile',
        plugins: [
          lazy(() => import('../pages/app-profile.js')),
        ],
        render: () => html`<app-profile></app-profile>`
      },

      {
        path: resolveRouterPath('select-fixture-page'),
        title: 'Select Fixture Page',
        plugins: [
          lazy(() => import('../pages/app-select-fixture-page.js')),
        ],
        render: () => html`<app-select-fixture-page></app-select-fixture-page>`
      },
      {
        path: resolveRouterPath('selected-team-page'),
        title: 'Select Team Page',
        plugins: [
          lazy(() => import('../pages/app-selected-team-page.js')),
        ],
        render: () => html`<app-selected-team-page></app-selected-team-page>`
      },
      {
        path: resolveRouterPath('selected-oppo-team'),
        title: 'Select Opponent Team',
        plugins: [
          lazy(() => import('../pages/app-selected-oppo-team.js')),
        ],
        render: () => html`<app-selected-oppo-team></app-selected-oppo-team>`
      },

      {
        path: resolveRouterPath('selection'),
        title: 'Selection',
        plugins: [
          lazy(() => import('../pages/app-selection.js')),
        ],
        render: () => html`<app-selection></app-selection>`
      },

      {
        path: resolveRouterPath('enter-fixture'),
        title: 'Enter Fixture',
        plugins: [
          lazy(() => import('../pages/app-enter-fixture.js')),
        ],
        render: () => html`<app-enter-fixture></app-enter-fixture>`
      },

 {
        path: resolveRouterPath('payments'),
        title: 'Payment test',
        plugins: [
          lazy(() => import('../pages/app-payments.js')),
        ],
        render: () => html`<app-payments></app-payments>`
      },


      {
        path: resolveRouterPath('terms'),
        title: 'Terms',
        plugins: [
          lazy(() => import('../pages/app-terms.js')),
        ],
        render: () => html`<app-terms></app-terms>`
      },
      {
        path: resolveRouterPath('fantasy-rules'),
        title: 'Fantasy-Rules',
        plugins: [
          lazy(() => import('../pages/app-fantasy-rules.js')),
        ],
        render: () => html`<app-fantasy-rules></app-fantasy-rules>`
      },
      {
        path: resolveRouterPath('stats-entry'),
        title: 'Stat Entry',
        plugins: [
          lazy(() => import('../pages/app-stats-entry.js')),
        ],
        render: () => html`<app-stats-entry></app-stats-entry>`
      },

      {
        path: resolveRouterPath('score-entry'),
        title: 'Stat Entry',
        plugins: [
          lazy(() => import('../pages/app-score-entry.js')),
        ],
        render: () => html`<app-score-entry></app-score-entry>`
      },
      {
        path: resolveRouterPath('fantasy-entry'),
        title: 'Fantasy Entry',
        plugins: [
          lazy(() => import('../pages/app-fantasy-entry.js')),
        ],
        render: () => html`<app-fantasy-entry></app-fantasy-entry>`
      },
      {
        path: resolveRouterPath('badge-detail'),
        title: 'Badge Details',
        plugins: [
          lazy(() => import('../pages/app-badge-detail.js')),
        ],
        render: () => html`<app-badge-detail></app-badge-detail>`
      },
      {
        path: resolveRouterPath('merge-player-data'),
        title: 'Merge Player Data',
        plugins: [
          lazy(() => import('../pages/app-merge-player-data.js')),
        ],
        render: () => html`<app-merge-player-data></app-merge-player-data>`
      },
      {
        path: resolveRouterPath('stats-upload'),
        title: 'Stats Upload',
        plugins: [
          lazy(() => import('../pages/app-stats-upload.js')),
        ],
        render: () => html`<app-stats-upload></app-stats-upload>`
      },


      {
        path: resolveRouterPath('finance'),
        title: 'Finance',
        plugins: [
          lazy(() => import('../pages/app-finance.js')),
        ],
        render: () => html`<app-finance></app-finance>`
      },


      {
        path: resolveRouterPath('user-finance'),
        title: 'User Finance',
        plugins: [
          lazy(() => import('../pages/app-user-finance.js')),
        ],
        render: () => html`<app-user-finance></app-user-finance>`
      },

      {
        path: resolveRouterPath('laws'),
        title: 'Laws',
        plugins: [
          lazy(() => import('../pages/app-laws.js')),
        ],
        render: () => html`<app-laws></app-laws>`
      },

      {
        path: resolveRouterPath('club-store'),
        title: 'Club Store',
        plugins: [
          lazy(() => import('../pages/app-club-store.js')),
        ],
        render: () => html`<app-club-store></app-club-store>`
      },

      {
        path: resolveRouterPath('fine-entry'),
        title: 'Fine Entry',
        plugins: [
          lazy(() => import('../pages/app-fine-entry.js')),
        ],
        render: () => html`<app-fine-entry></app-fine-entry>`
      },

      {
        path: resolveRouterPath('news-entry'),
        title: 'News Entry',
        plugins: [
          lazy(() => import('../pages/app-news-entry.js')),
        ],
        render: () => html`<app-news-entry></app-news-entry>`
      },

      {
        path: resolveRouterPath('news/:newsId'),
        title: 'News Details',
        plugins: [
          lazy(() => import('../pages/app-news-details.js')),
        ],
        render: (context) => html`<app-news-details .newsId=${context.params.newsId}></app-news-details>`
      },

      {
        path: resolveRouterPath('awards'),
        title: 'Awards',
        plugins: [
          lazy(() => import('../pages/app-awards.js')),
        ],
        render: () => html`<app-awards></app-awards>`
      },

      {
        path: resolveRouterPath('events'),
        title: 'Events',
        plugins: [
          lazy(() => import('../pages/app-events.js')),
        ],
        render: () => html`<app-events></app-events>`
      },
      {
        path: resolveRouterPath('enter-event'),
        title: 'Enter Event',
        plugins: [
          lazy(() => import('../pages/app-enter-event.js')),
        ],
        render: () => html`<app-enter-event></app-enter-event>`
      },
      {
        path: resolveRouterPath('support-ticket'),
        title: 'Support Ticket',
        plugins: [
          lazy(() => import('../pages/app-support-ticket.js')),
        ],
        render: () => html`<app-support-ticket></app-support-ticket>`
      },
      {
        path: resolveRouterPath('support-admin'),
        title: 'Support Admin',
        plugins: [
          lazy(() => import('../pages/app-support-admin.js')),
        ],
        render: () => html`<app-support-admin></app-support-admin>`
      },

      {
        path: resolveRouterPath('fines'),
        title: 'Fines',
        plugins: [
          lazy(() => import('../pages/app-fines.js')),
        ],
        render: () => html`<app-fines></app-fines>`
      },


      {
        path: resolveRouterPath('admin-update-strike-rate'),
        title: 'ds Batting Stats',
        plugins: [
          lazy(() => import('../pages/app-admin-update-strike-rate')),
        ],
        render: () => html`<app-admin-update-strike-rate></app-admin-update-strike-rate>`
      },

      {
        path: resolveRouterPath('admin'),
        title: 'Admin',
        plugins: [
          lazy(() => import('../pages/app-admin.js')),
        ],
        render: () => html`<app-admin></app-admin>`
      },
      {
        path: resolveRouterPath('settings'),
        title: 'Settings',
        plugins: [
          lazy(() => import('../pages/app-settings.js')),
        ],
        render: () => html`<app-settings></app-settings>`
      },

      {
        path: resolveRouterPath('finance-player'),
        title: 'Finance Player',
        plugins: [
          lazy(() => import('../pages/app-finance-player.js')),
        ],
        render: () => html`<app-finance-player></app-finance-player>`
      },

      {
        path: resolveRouterPath('finance-admin'),
        title: 'Finance Admin',
        plugins: [
          lazy(() => import('../pages/app-finance-admin.js')),
        ],
        render: () => html`<app-finance-admin></app-finance-admin>`
      },

        {
        path: resolveRouterPath('player-profile'),
        title: 'Player Profile',
        plugins: [
          lazy(() => import('../pages/app-player-profile.js')),
        ],
        render: () => html`<app-player-profile></app-player-profile>`
      },

       {
        path: resolveRouterPath('social-scoreboard'),
        title: 'Social Scoreboard',
        plugins: [
          lazy(() => import('../pages/app-social-scoreboard.js')),
        ],
        render: () => html`<app-social-scoreboard></app-social-scoreboard>`
      },

      {
        path: resolveRouterPath('match-entry'),
        title: 'Match Entry',
        plugins: [
          lazy(() => import('../pages/app-match-entry.js')),
        ],
        render: () => html`<app-match-entry></app-match-entry>`
      },

      {
  path:  resolveRouterPath('join'),
  title: "Join club",
    plugins: [lazy(() => import("../pages/app-join.js"))],
    render: () => html`<app-join></app-join>`,
},
{
  path: resolveRouterPath("admin-invites"),
  title: "Invites",
  plugins: [lazy(() => import("../pages/app-admin-invites.js"))],
  render: () => html`<app-admin-invites></app-admin-invites>`,
},
{
  path: resolveRouterPath("admin-players"),
  title: "Players",
  plugins: [lazy(() => import("../pages/app-admin-players.js"))],
  render: () => html`<app-admin-players></app-admin-players>`,
},
{
  path: resolveRouterPath("admin-teams"),
  title: "Teams",
  plugins: [lazy(() => import("../pages/app-admin-teams.js"))],
  render: () => html`<app-admin-teams></app-admin-teams>`,
},
{
  path: resolveRouterPath("admin-members"),
  title: "Members & Roles",
  plugins: [lazy(() => import("../pages/app-admin-members.js"))],
  render: () => html`<app-admin-members></app-admin-members>`,
},

{
  path: resolveRouterPath("admin-club-settings"),
  title: "Club Settings",
  plugins: [lazy(() => import("../pages/app-admin-club-settings.js"))],
  render: () => html`<app-admin-club-settings></app-admin-club-settings>`,
},

{
  path: resolveRouterPath("admin-bulk-invites"),
  title: "Bulk Invites",
  plugins: [lazy(() => import("../pages/app-admin-bulk-invites.js"))],
  render: () => html`<app-admin-bulk-invites></app-admin-bulk-invites>`,
},

{
  path: resolveRouterPath("platform"),
  title: "Platform",
  plugins: [lazy(() => import("../pages/app-platform.js"))],
  render: () => html`<app-platform></app-platform>`,
},

{
  path: resolveRouterPath("club-switcher"),
  title: "Club Switcher",
  plugins: [lazy(() => import("../pages/app-club-switcher.js"))],
  render: () => html`<app-club-switcher></app-club-switcher>`,
},
{
  path: resolveRouterPath("admin-seasons"),
  title: "Admin Seasons",
  plugins: [lazy(() => import("../pages/app-admin-seasons.js"))],
  render: () => html`<app-admin-seasons></app-admin-seasons>`,
},
{
  path: resolveRouterPath("admin-honours-board"),
  title: "Admin Honours Board",
  plugins: [lazy(() => import("../pages/app-admin-honours-board.js"))],
  render: () => html`<app-admin-honours-board></app-admin-honours-board>`,
},
{
  path: resolveRouterPath('finance/success'),
  title: 'Payment Success',
  plugins: [
    lazy(() => import('../pages/app-finance-success.js')),
  ],
  render: () => html`<app-finance-success></app-finance-success>`
},
{
  path: resolveRouterPath('finance/cancel'),
  title: 'Payment Cancelled',
  plugins: [
    lazy(() => import('../pages/app-finance-cancel.js')),
  ],
  render: () => html`<app-finance-cancel></app-finance-cancel>`
},

    ],


plugins: [
  routeGuardPlugin,
  titlePlugin,

],

  });




  // This function will resolve a path with whatever Base URL was passed to the vite build process.
  // Use of this function throughout the starter is not required, but highly recommended, especially if you plan to use GitHub Pages to deploy.
  // If no arg is passed to this function, it will return the base URL.

